/**
 * 新版本接口
 * https://zl.wps.cn/a/Yz5duy?from=467Q83D
 */

import { ua } from '@/utils/tools'

function _caller (json) {
  // ios端
  if (window.webkit?.messageHandlers?.wps_web_query?.postMessage) {
    return window.webkit.messageHandlers.wps_web_query.postMessage(json)
  }
  // android端
  if (window?.wps_web_query?.invoke) {
    return window.wps_web_query.invoke(JSON.stringify(json))
  }
  // pc
  if (typeof window.wps_web_query === 'function') {
    window.wps_web_query(json)
  } else {
    throw new Error('api unsupport')
  }
}
interface IConfig {
  mdocs?: boolean
  mWOA?:boolean
}
function call (api: string | { method:string, version?: string }, params = {}):Promise<unknown> {
  return new Promise((resolve, reject) => {
    const _method = typeof api === 'string' ? api : api.method
    const callbackName = `${_method.replace(/\./g, '_')}_` + Date.now()
    const data = {
      method: _method,
      params,
      callback: callbackName,
      version: typeof api === 'string' ? undefined : api.version
    }
    window[callbackName] = (res) => {
      try {
        if (typeof res === 'string') {
          res = JSON.parse(res)
        }
        const { callstatus, result } = res
        if (callstatus === 'ok') {
          resolve(result)
        } else {
          reject(res)
        }
      } catch (e) {
        console.log('api error', e)
        reject(e)
      }
      delete window[callbackName]
    }

    try {
      _caller(data)
    } catch (e) {
      reject(e)
    }
  })
}

// 某些api有版本区分
const API_VERSION_MAP = {
  'api.check': {
    mdocs: '1.0',
    mwoa: '1.0.2'
  },
  'api.list': {
    mdocs: '1.0',
    mwoa: '1.0.2'
  }
}
class PublicBridge {
  readonly isMdocs: boolean
  readonly isMwoa: boolean
  constructor (config:IConfig) {
    const { mdocs, mWOA } = config
    this.isMdocs = !!mdocs
    this.isMwoa = !!mWOA
  }

  private getApiVersion (api): string|undefined {
    const verionMap = API_VERSION_MAP[api]
    if (verionMap) {
      if (this.isMwoa) {
        return verionMap.mwoa
      } else if (this.isMdocs) {
        return verionMap.mdocs
      }
    }
  }

  async isSupport (api: string):Promise<boolean> {
    const version = this.getApiVersion('api.check')
    try {
      const res = await call({ method: 'api.check', version }, {
        apis: [api]
      }) as Record<string, boolean>
      return ['true', true].includes(res[api])
    } catch (e) {
      return false
    }
  }

  call (api:string, params:Record<string, unknown> = {}, version?:string) {
    const _version = version || this.getApiVersion(api)
    if (_version) {
      return call({ method: api, version: _version }, params)
    }
    return call(api, params)
  }
}

export default new PublicBridge({ mdocs: ua.mdocs, mWOA: ua.mWOA })
